// removed by extract-text-webpack-plugin
module.exports = {"component":"_2PZEskAfxGOOEgMc6AooNs","userBadge":"_2_bN-uY6euVXPjhKAI99HL","info":"SDv4rlbYOJTq2S2HqXAcs","flex":"_1A7T6Kbqx02nEWGl1z-W_i","action":"_1KsTgk1Ui3S46ENH3lAPZT","hiddenAction":"i3dHHeRMxqasooSPc8aic","primaryText":"_1puLkqxsjLpu1QNZXmNqff"};


//////////////////
// WEBPACK FOOTER
// ./src/components/User/User.css
// module id = 1014
// module chunks = 0